import { MapDrawSelectionChangeEventData } from './map-draw-selection-change-event-data';
import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MapDrawSelectionChangeEvent implements MapEvent {
    type = MapEventType.mapDrawSelectionChanged;
    constructor(public payload: MapDrawSelectionChangeEventData) {}
}
